var c = { BUCKET_URL: "https://cdn.memooria.org" };
const l = {
  getVar: (e) => c[e]
}, t = l.getVar("BUCKET_URL"), g = (e) => `${t}/image/${e}`;
let n = !1;
function d() {
  n || (n = !0, document.body.addEventListener(
    "error",
    (e) => {
      if (e.target && e.target.tagName === "IMG") {
        const r = e.target.src, a = new RegExp(`${t.replace(/\./g, "\\.")}/image/.*/logo\\.png`), s = new RegExp(`${t.replace(/\./g, "\\.")}/image/.*/logo-mobile\\.png`), i = new RegExp(`${t.replace(/\./g, "\\.")}/image/.*/credits\\.png`);
        if (a.test(r))
          e.target.src = `${t}/image/default/logo.png`;
        else if (s.test(r))
          e.target.src = `${t}/image/default/logo-mobile.png`;
        else if (i.test(r))
          e.target.src = `${t}/image/default/credits.png`;
        else
          return;
        console.error(`Assets Service - Failed to load image: ${r}`, "it will be replaced with the default one");
      }
    },
    !0
  ));
}
function o() {
  d();
}
const m = {
  getLogoImage: (e) => (o(), `${g(e)}/logo.png`),
  getLogoMobile: (e) => (o(), `${g(e)}/logo-mobile.png`),
  getCreditsImage: (e) => (o(), `${g(e)}/credits.png`),
  getSvgIcon: (e) => `${t}/svg/${e}`
};
export {
  m as AssetsService
};
